import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { save as checkupSave } from "../../requests/checkup.js";

export default function useCheckupAppointment(props) {

  const [appointmentForm, setAppointmentForm] = createStore({
    notes: props.appointment?.notes || "",
  });

  const { successToast, errorToast } = useApplication();

  const handleAppointmentInput = (name, value) => {
    setAppointmentForm([name], value);
  }

  const onSaveAppointment = async () => {
    props.setLoading(true);
    try {
      const formData = new FormData();
      // Ensure notes is never empty or null by providing a default empty string
      formData.append('notes', appointmentForm.notes || "");

      const data = await checkupSave(formData);

      if (data.success) {
        successToast(data.message || "Appointment saved successfully");
      } else {
        errorToast(data.message || "Failed to save appointment");
      }
    } catch(error) {
      errorToast("Failed to save appointment");
    } finally {
      props.setLoading(false);
    }
  }

  return {
    appointmentForm,
    onSaveAppointment,
    handleAppointmentInput,
  };
} 